import React from 'react'
import { Alert } from "react-bootstrap";

import MainMenu from '../../_components/MainMenu';
import MainFooter from '../../_components/MainFooter';
import PreLoader from "../../_components/PreLoader";
//services
import { menuService } from '../../_services/menu.service';
import { cartService } from '../../_services/cart.service';
import { settingsService } from '../../_services/settings.service';
import { formatPrice } from "../../_helpers";

import Paynamics from "./Paynamics"

import Swal from 'sweetalert2/dist/sweetalert2.js'
import { userService } from '../../_services/user.service';
import { postService } from '../../_services/post.service';
import Cities from "../UserProfile/Cities.json";



class Checkout extends React.Component {
    constructor(props) {
        super(props);
  
        this.state = {
            loading: true,
            user: {
                details: {}
            },
            menu: {},
            topbarMenu: {},
            branches: {
                items: []
            },
            cart:{
                items: []
            },
            useBilling: true,
            shipping: {
                address_1:'',
                address_2:'',
                country:'',
                city:'',
                email:'',
                first_name:'',
                last_name:'',
                phone:'',
                postcode:'',
                state:'',
                remarks: '',
                barangay: '',
            },
            showAlert: true,
            settings: [],
            countries: [],
            selectedState:[],
            shippingCosts: [],
            selectedCity: {},
            selectedBarangay:[],
            cityNames: [],
        };
  
        // this.checkShipping = this.checkShipping.bind(this);
        this.updateQuantity = this.updateQuantity.bind(this);
        this.updateCart = this.updateCart.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleShipToBilling = this.handleShipToBilling.bind(this);
        this.cartRef = React.createRef();
    }

    handleShipToBilling = (e) => {
        const { useBilling, user } = this.state;
        const newUseBilling = !useBilling;
    
        let shipping = {};
    
        if (newUseBilling && user && user.billing) {
            
            if (!user.billing.first_name && !user.billing.last_name && !user.billing.address_1) {
                Swal.fire({
                    position: 'center',
                    icon: 'warning',
                    title: 'Signup Now!',
                    html: 'You need to signup for an account to save your billing information and use it as your shipping address.',
                    showConfirmButton: true
                });
            }
    
            shipping = {
                first_name: user.billing.first_name,
                last_name: user.billing.last_name,
                address_1: (user.billing.address_1 ? user.billing.address_1 + ', ' : '') + (user.billing.address_2 ? user.billing.address_2 + ', ' : '') + '' + (user.billing.country || ''),
                address_2: user.billing.address_2,
                postcode: user.billing.postcode,
                city: user.billing.city,
                email: user.billing.email,
                phone: user.billing.phone,
                country: user.billing.country,
                state: user.billing.state,
                barangay: user.billing.barangay,
            };
        } else {
            shipping = {
                first_name: '',
                last_name: '',
                address_1: '',
                address_2: '',
                postcode: '',
                city:'',
                email: '',
                phone: '',
                country: '',
                state: '',
                barangay: ''
            };
        }
    
        this.setState({
            useBilling: newUseBilling,
            shipping: shipping
        });
    }
    

    handleChange(e) {
        const { name, value } = e.target;
        this.setState(prevState => ({
            shipping: {
                ...prevState.shipping,
                [name]: value
            }
        }), this.checkAndFetchShippingFee);
    }


    updateCart(){
        this.cartRef.current.updateCart();
    }

    updateQuantity(){
        Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: 'quantity updated',
            showConfirmButton: false,
            timer: 1500
          })
    }

    setShipping(){
        Swal.fire({
            position: 'top-end',
            icon: 'error',
            title: 'Complete Shipping Address',
            showConfirmButton: false,
            timer: 1500
          })
    }

    getSubTotal (items = []) {
        return items.reduce((acc, item) => {
            const itemQuantity = parseFloat(item.q.toString().split(",").join(""));
            const itemPrice = parseFloat(item.c.toString().split(",").join(""));

            return acc + (itemPrice * itemQuantity);
        }, 0);
    }

    componentDidMount() {
        const user = JSON.parse(localStorage.getItem('user'));
        
    
        if (user) {
            userService.getCustomers(user.id)
                .then(userDetails => {
                    this.setState({ user: userDetails });

                    //console.log(this.state.useBilling)
    
                    if (this.state.useBilling) {
                        const { billing } = userDetails;
                        //console.log(billing)
    
                        // Use setState with a callback to ensure shipping is updated before getting the fee
                        this.setState(prevState => ({
                            shipping: {
                                ...prevState.shipping,
                                first_name: user.first_name || '',
                                last_name: user.last_name || '',
                                address_1: user.address_1 || '',
                                address_2: billing?.address_2 || '',
                                city: billing?.city || '',
                                postcode: billing?.postcode || '',
                                email: user.user_email|| '',
                                phone: billing?.phone || '',
                                country: billing?.country || 'PH', // Default country 'PH'
                                state: billing?.state || '',
                                barangay: billing?.barangay || ''  // Include barangay if needed
                            }
                        }), () => {
                            // Callback after state is set
                           
                            this.getShippingFee(this.state.shipping, this.state.cart.totals?.total_items);  // Now shipping info is ready
                        });
                    }
                })
                .catch(error => {
                    console.error('Error fetching user details:', error);
                });
        }   
    
        // Set the default country and states for Philippines (PH)
        userService.getCountries()
            .then(countryData => {
                const defaultCountryCode = "PH"; // Default country is Philippines
                const defaultCountryData = countryData.find(c => c.code === defaultCountryCode);
    
                this.setState({
                    countries: countryData,
                    shipping: {
                        ...this.state.shipping,
                        country: defaultCountryCode  // Set Philippines as default country
                    },
                    selectedState: defaultCountryData?.states || []  // Set states for Philippines
                });
            })
            .catch(error => {
                console.error('Error fetching countries:', error);
            });
    
        // Other async calls can go here...
        Promise.allSettled([
            menuService.getMenuByName('default').then(menu => this.setState({ menu })),
            menuService.getMenuByName('Topbar').then(topbarMenu => this.setState({ topbarMenu })),
            postService.getBranches('branch', 'branches').then(branchesData => this.setState({ branches: branchesData.items })),
            cartService.getAllCart().then(cart => this.setState({ cart })),
            settingsService.getAll().then(settings => this.setState({ settings }))
        ]).then(() => this.setState({ loading: false }));
    
        this.getCities();  // Fetch cities after mounting
    }
    

    componentDidUpdate(prevProps, prevState) {
        // Check if the shipping state has changed
        if (prevState.shipping.state !== this.state.shipping.state) {
            this.loadCities();
        }
    }

    loadCities() {
        const { state, city } = this.state.shipping;
        const citiesList = Cities[state] || {};
        
        // Extract details for the selected city
        const selectedCity = citiesList[city] || {};
        const barangays = selectedCity.Barangays || [];

        
        this.setState({
            selectedCity: citiesList,
            cityNames: Object.keys(citiesList),
            selectedBarangay: barangays // Update the barangay options
        }, () => {
            // Ensure the barangay is correctly set if it's part of the new list
            if (barangays.includes(this.state.shipping.barangay)) {
                this.setState(prevState => ({
                    shipping: {
                        ...prevState.shipping,
                        barangay: prevState.shipping.barangay // Ensure barangay is still set
                    }
                }));
            }
        });
    }
    

    getCities() {
        //console.log(this.state.shipping.state);
    }


    getShippingFee(customerBillingInfo, orderAmount) {
        // console.log(customerBillingInfo)
        // console.log(orderAmount)
        settingsService.getShippingCost(customerBillingInfo,orderAmount)
            .then(shippingCosts => {
                // Update the state with the shipping costs
                this.setState({ shippingCosts: shippingCosts });
                //console.log('Final shipping costs:', shippingCosts);
            })
            .catch(error => {
                console.error('Error:', error);
            });
    }

    handleCityChange = (event) => {

        const selectedCity = event.target.value;
        const postcode = this.state.selectedCity[selectedCity] || '';
        const stateCode = this.state.shipping.state
        const barangayNames = postcode.Barangays?.map(barangay => barangay.Name);

        this.setState(prevState => ({
            shipping: {
                ...prevState.shipping,
                city: selectedCity,
                postcode: stateCode !== '00' ? postcode.ZipCode : prevState.shipping.postcode,
            },
            selectedBarangay: stateCode !== '00' ? postcode.Barangays : barangayNames
        }),this.checkAndFetchShippingFee, () => {
            // Optionally, you can call a method here if you want to do something after the postcode is updated
            //console.log('City and Postcode updated:', this.state.shipping.city, this.state.shipping.postcode);
        });
    }
    

    handleBarangayChange = (event) => {
        const selectedBarangay = event.target.value;
        const postcode = this.state.selectedCity[this.state.shipping.city] || '';
        const stateCode = this.state.shipping.state
        const selectedBarangayData = postcode.Barangays.find(barangay => barangay.Name === selectedBarangay);
    
        // Ensure the selected barangay is in the list of available barangays
        if (this.state.selectedBarangay.includes(selectedBarangay)) {
            this.setState(
                prevState => ({
                    shipping: {
                        ...prevState.shipping,
                        postcode: stateCode === '00' ? selectedBarangayData.ZipCode : prevState.shipping.postcode, //stateCode === '00' ? postcode.ZipCode : prevState.shipping.postcode,
                        barangay: selectedBarangay,
                        
                    },
                }),this.checkAndFetchShippingFee,
                () => {
                    //console.log('Barangay selected:', this.state.shipping.barangay);
                }
            );
        } else {
            //console.warn("Selected barangay is not in the available list.");
        }
    };
    

    checkAndFetchShippingFee() {
        const { city, state, postcode, barangay, country } = this.state.shipping;
        
        // Ensure that all required fields are populated before fetching the shipping fee
        if (city && state && postcode && barangay && country) {
            //console.log("Fetching shipping fee with:", this.state.shipping);
            // console.log(this.state.cart.totals?.total_items)
            this.getShippingFee(this.state.shipping, this.state.cart.totals?.total_items);
        } else {
            //console.log("Not all fields are filled yet. Current state:", this.state.shipping);
        }
    }
    

    render() {

        const { loading, user, menu, topbarMenu, branches, cart, settings, shipping, countries,selectedState ,shippingCosts, cityNames, selectedBarangay} = this.state;

        const formatCurrency = (value) => {
            return new Intl.NumberFormat('en-PH', {
              style: 'currency',
              currency: 'PHP',
              minimumFractionDigits: 0,
              maximumFractionDigits: 0
            }).format(value);
          };


        // Calculate total shipping cost
        const totalShippingCost = shippingCosts.reduce((total, costObj) => total + parseFloat(costObj.cost), 0);

        const itemPricesTotal = (cart?.totals?.total_items || 0)
        // Function to format numbers with commas and two decimal places
        // Assuming itemPricesTotal and totalShippingCost are numbers
        const formattedItemPricesTotal = formatPrice(itemPricesTotal,{ isCartPrice: true });
        const formattedTotalShippingCost = formatPrice(totalShippingCost);

        const parsedItemPricesTotal = parseFloat(formattedItemPricesTotal.replace(/[^\d.-]/g, ''));
        const parsedTotalShippingCost = parseFloat(formattedTotalShippingCost.replace(/[^\d.-]/g, ''));

        // Calculate grand total
        const grandTotal = parsedItemPricesTotal + parsedTotalShippingCost;

        return (
            <div>
                <PreLoader loading={loading} />
                <MainMenu user={user} menu={menu} ref={this.cartRef} topbarMenu={topbarMenu}/>
                <div className="jumbotron page-title py-5">
                    <div className="container">
                        <h1 className="text-white">Checkout</h1>
                    </div>
                </div>
                {settings &&
                <section className="m-md-5">
                    <div className="container">
                        <div className="row">
                            <div className="col-sm-12 col-md-12 col-lg-8">
                                <form action="">
                                    <div className="form-row">
                                        <div className="col-12">
                                            <h3 className="mt-4 mb-3">Shipping Address</h3>
                                            <hr />
                                        </div>      
                                        {this.state.showAlert && <Alert variant="warning" onClose={() => this.setState({ showAlert: false })} dismissible>
                                            <p></p>
                                            <p>
                                                Except for the Order Notes, please note that <strong>All Fields are Required Fields</strong> and must be accomplished in full to proceed with the Checkout process.
                                            </p>
                                            <p>
                                                You can list any special instructions on the Order Notes. We will try to follow them as best we can.
                                            </p>
                                          </Alert>          }                    
                                        <div className="form-group col-6">
                                            <label htmlFor="">First Name</label>
                                            <input type="text" name="first_name" className={`form-control ${!shipping.first_name && "is-invalid"}`} onChange={this.handleChange} value={shipping.first_name}/>
                                            {!shipping.first_name &&
                                                <small className="text-danger">First Name is required.</small>
                                            }
                                        </div>
                                        <div className="form-group col-6">
                                            <label htmlFor="">Last Name</label>
                                            <input type="text" name="last_name" className={`form-control ${!shipping.last_name && "is-invalid"}`} onChange={this.handleChange} value={shipping.last_name}/>
                                            {!shipping.last_name &&
                                                <small className="text-danger">Last Name is required.</small>
                                            }
                                        </div>
                                        <div className="form-group col-6">
                                            <label htmlFor="">Email Address</label>
                                            <input type="text" name="email" className={`form-control ${!shipping.email && "is-invalid"}`} onChange={this.handleChange} value={shipping.email}/>
                                            {!shipping.email &&
                                                <small className="text-danger">Email is required.</small>
                                            }
                                        </div>
                                        <div className="form-group col-6">
                                            <label htmlFor="">Phone Number</label>
                                            <input type="text" name="phone" className={`form-control ${!shipping.phone && "is-invalid"}`} onChange={this.handleChange} value={shipping.phone}/>
                                            {!shipping.phone &&
                                                <small className="text-danger">Phone Number is required.</small>
                                            }
                                        </div>
                                        <div className="form-group col-12">
                                            <label htmlFor="">Address 1</label>
                                            <input type="text" name="address_1" className={`form-control ${!shipping.address_1 && "is-invalid"}`} onChange={this.handleChange} value={shipping.address_1}/>
                                            {!shipping.address_1 &&
                                                <small className="text-danger">Address is required.</small>
                                            }
                                        </div>
                                        <div className="form-group col-12">
                                            <label htmlFor="">Address 2</label>
                                            <input type="text" name="address_2" className={`form-control ${!shipping.address_2 }`} onChange={this.handleChange} value={shipping.address_2}/>
                                            {/* {!shipping.address_2 &&
                                                <small className="text-danger">Address 2 is required.</small>
                                            } */}
                                        </div>
                                        <div className="form-group col-sm-6 col-md-3">
                                            <label htmlFor="countrySelect">Country</label>
                                            <select
                                                name="country"
                                                id="countrySelect"
                                                className={`form-control ${!shipping.country && "is-invalid"}`}
                                                onChange={(e) => {
                                                    const selectedCountryCode = e.target.value;
                                                    const selectedCountry = countries.find(country => country.code === selectedCountryCode);
                                                    const selectedState = selectedCountry ? selectedCountry.states || [] : [];
                                                    
                                                    this.setState(prevState => ({
                                                        shipping: {
                                                            ...prevState.shipping,
                                                            country: selectedCountryCode, // Update to store only the country code
                                                            state: '', // Reset state when country changes
                                                        },
                                                        selectedState: selectedState,
                                                    }));
                                                }}
                                                value={shipping.country} // Use shipping.country directly for default selection
                                                disabled
                                            >
                                                <option value="" disabled>Choose...</option>
                                                {countries?.map((country) => (
                                                    <option key={country.code} value={country.code}>
                                                        {country.name}
                                                    </option>
                                                ))}
                                            </select>
                                            {!shipping.country &&
                                                <small className="text-danger">Country is required.</small>
                                            }
                                        </div>

                                        <div className="form-group col-sm-6 col-md-3">
                                            <label htmlFor="stateSelect">Province</label>
                                            <select
                                                id="stateSelect"
                                                className={`form-control ${!shipping.state && "is-invalid"}`}
                                                name="state"
                                                onChange={(e) => {
                                                    const selectedStateCode = e.target.value;
                                                    this.setState(prevState => ({
                                                        shipping: {
                                                            ...prevState.shipping,
                                                            state: selectedStateCode,
                                                        },
                                                    }));
                                                }}
                                                value={shipping.state}
                                            >
                                                <option value="" disabled>Choose...</option>
                                                {Array.isArray(selectedState) && selectedState.map((state) => (
                                                    <option key={state.code} value={state.code}>
                                                        {state.name}
                                                    </option>
                                                ))}
                                            </select>
                                            {!shipping.state &&
                                                <small className="text-danger">Province is required.</small>
                                            }
                                        </div>

                                        <div className="form-group col-sm-6 col-md-3">
                                            <label htmlFor="stateSelect">City/Municipality</label>
                                            <select
                                                id="stateSelect"
                                                className={`form-control ${!shipping.city && "is-invalid"}`}
                                                name="state"
                                                // onChange={(e) => {
                                                //     const selectedStateCode = e.target.value;
                                                //     this.setState(prevState => ({
                                                //         shipping: {
                                                //             ...prevState.shipping,
                                                //             city: selectedStateCode,
                                                //         },
                                                //     }));
                                                // }}
                                                onChange={this.handleCityChange}
                                                value={shipping.city}
                                            >
                                                <option value="" disabled>Choose...</option>
                                                {Array.isArray(cityNames) && cityNames.map((state) => (
                                                    <option key={state} value={state}>
                                                        {state}
                                                    </option>
                                                ))}
                                            </select>
                                            {!shipping.city &&
                                                <small className="text-danger">City is required.</small>
                                            }
                                        </div>

                                        <div className="form-group col-sm-6 col-md-3">
                                            <label htmlFor="stateSelect">Barangay</label>
                                            <select
                                                id="stateSelect"
                                                className={`form-control ${!shipping.barangay && "is-invalid"}`}
                                                name="barangay"
                                                onChange={this.handleBarangayChange}
                                                value={shipping.barangay || ''}
                                            >
                                                <option value="" disabled>Choose...</option>
                                                {Array.isArray(selectedBarangay) && selectedBarangay.map((state) => (
                                                    <option key={state} value={state}>
                                                        {state}
                                                    </option>
                                                ))}
                                            </select>
                                            {!shipping.barangay &&
                                                <small className="text-danger">Barangay is required.</small>
                                            }
                                        </div>

                                        {/* <div className="form-group col-3">
                                            <label htmlFor="">City</label>
                                            <input type="text"  id="zip" className={`form-control ${!shipping.city && "is-invalid"}`} name="city" onChange={this.handleChange} value={shipping.city}/>
                                            {!shipping.city &&
                                                <small className="text-danger">City is required.</small>
                                            }
                                        </div> */}
                                        
                                        {/* <div className="form-group col-3">
                                            <label htmlFor="">Barangay</label>
                                            <input type="text"  id="barangay" className={`form-control ${!shipping.barangay && "is-invalid"}`} name="barangay" onChange={this.handleChange} value={shipping.barangay}/>
                                            {!shipping.barangay &&
                                                <small className="text-danger">Barangay is required.</small>
                                            }
                                        </div> */}

                                        <div className="form-group col-sm-6 col-md-3">
                                            <label htmlFor="">Zip Code</label>
                                            <input type="text"  id="zip" className={`form-control ${!shipping.postcode && "is-invalid"}`} name="postcode" onChange={this.handleChange} value={shipping.postcode} readOnly/>
                                            {!shipping.postcode &&
                                                <small className="text-danger">Zip is required.</small>
                                            }
                                        </div>

                                        <div className="form-group col-12 my-3">
                                            <div className="custom-control custom-switch">
                                                <input
                                                    type="checkbox"
                                                    className="custom-control-input"
                                                    id="shipToBilling"
                                                    checked={this.state.useBilling}
                                                    onChange={this.handleShipToBilling}
                                                />
                                                <label className="custom-control-label" htmlFor="shipToBilling">
                                                    {this.state.useBilling ? 'Clear shipping address?' : 'Ship to Billing address?'}
                                                </label>
                                            </div>
                                        </div>           
                                    </div>
                                    

                                {settings && Array.isArray(settings) && settings.length > 0 && (
                                    <div className="row">
                                        <div className="col-12">
                                        <h3 className="mt-4 mb-3">Shipping Details</h3>
                                        <table className="table table-bordered my-3">
                                            <thead className="thead-light">
                                            <tr>
                                                <th>Location</th>
                                                <th>Shipping Fee <small>(Below {formatCurrency(settings.some(setting => setting.methods.some(method => method.title === "Free shipping")) ? settings.find(setting => setting.methods.some(method => method.title === "Free shipping")).methods.find(method => method.title === "Free shipping").minimumOrderAmount?.value : "")})</small></th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {settings.map(setting => (
                                                setting.methods
                                                .filter(method => method.title === 'Flat rate')
                                                .map(method => (
                                                    <tr key={`${setting.id}-${method.instance_id}`}>
                                                    <td>{setting.name}</td>
                                                    <td>{formatCurrency(method.cost.value)}</td>
                                                    </tr>
                                                ))
                                            ))}
                                            <tr>
                                                <th colSpan="2">
                                                Free shipping above {formatCurrency(settings.some(setting => setting.methods.some(method => method.title === "Free shipping")) ? settings.find(setting => setting.methods.some(method => method.title === "Free shipping")).methods.find(method => method.title === "Free shipping").minimumOrderAmount?.value : "")} to any point in the Philippines <br />
                                                </th>
                                            </tr>
                                            </tbody>
                                        </table>
                                        </div>
                                    </div>
                                )}


                                <div className="form-row">
                                        <div className="form-group col-12 my-3">
                                            <label htmlFor="">
                                                Order Notes
                                            </label>
                                            <textarea name="remarks" id="" cols="30" rows="4" className="form-control" placeholder="Notes about your order, e.g. special notes for delivery." onChange={this.handleChange} value={shipping.remarks}></textarea>
                                        </div>                                    
                                    </div>                            
                                </form>
                                <ul className="nav border-top mt-3 pt-2">
                                    <li className="nav-item"><a href="/page/shipping-information" target="_blank" className="nav-link active"><small>Shipping Information</small></a></li>
                                    <li className="nav-item"><a href="/page/service-policy" target="_blank" className="nav-link active"><small>Service Policy</small></a></li>
                                </ul>                     
                            </div>
                      
                    <div className="col-sm-12 col-md-12 col-lg-4">
                            <div className="card p-4">
                                <h3 className="mb-4 text-center">Order Summary</h3>
                                <div className="widget cart-items-widget">
                                    {cart && cart.items && cart.items.map((item, index) =>
                                        <div className="media border-bottom pt-3" key={index}>
                                            {item.images &&
                                                <img width="64" src={item.images[0].thumbnail} className="img-thumbnail d-block rounded mr-3" alt="..." />
                                            }
                                            <div className="media-body">
                                                <h5 className="mt-0"><a href={item.permalink}>{item.name}</a></h5>
                                                {/* <p className="m-0 mb-2"><small><strong>Model:</strong> {item.m}</small></p> */}
                                                <p><span className="text-primary">{formatPrice(item.prices.price,{ isCartPrice: true })}</span> x {item.quantity}</p>
                                            </div>
                                        </div>
                                    )}
                                </div>
                                <ul className="list-unstyled border-bottom">
                                    <li className="d-flex justify-content-between align-items-center my-2">
                                        <span className="mr-2">Subtotal:</span>
                                        <strong className="text-right">{formatPrice(cart.totals?.total_items, { isCartPrice: true })}</strong>
                                    </li>

                                    <li className="d-flex justify-content-between align-items-center my-2" >
                                            <span className="mr-2">Shipping:</span>
                                            {
                                                shippingCosts.length !== 0 ?

                                                shippingCosts && shippingCosts.map((item, index) =>
                                                    
                                                        <strong className="text-right" key={index}>
                                                            {item.title === 'Free shipping' ? "FREE" : formatPrice(item.cost)}
                                                        </strong>
                                                    
                                                )

                                                :
                                                <strong className="text-right">
                                                    calculating...
                                                </strong>
                                            }
                                            
                                    </li>
                                   
                                </ul>
                                <h3 className="font-weight-normal text-center mt-2 mb-4 text-primary">{formatPrice(grandTotal)|| 0}</h3>
                                <p className="">
                                    <small>Your personal data will be used to process your order, support your experience throughout this website, and for other purposes described in our <a href="/">privacy policy</a>.</small>
                                </p>

                                    {Object.entries(shipping).every(([key, value]) => 
                                            (key === 'address_2' && (value === null || value === '')) || (!!value && key !== 'address_2') ||
                                            (key === 'remarks' && (value === null || value === '')) || (!!value && key !== 'remarks')
                                        ) ? (
                                            // <PaypalButton order={cart} shipping={shipping} />
                                            <Paynamics order={cart} shipping={shipping} grandTotal={grandTotal} shippingFee={shippingCosts} userDetails={user}/>
                                        ) : (
                                            <button className="btn btn-primary btn-block btn-lg" disabled>
                                                Please fill up all required shipping details
                                            </button>
                                        )}
                                </div>
                        </div>
                        </div>                
                    </div>
                </section>
                }
                <MainFooter menu={menu} branches={branches} />
            </div>
        )
    }
}

export { Checkout };